export default __webpack_public_path__ + "static/media/logo.f21982b7.webp";